// import React, { useState, useEffect, useCallback } from "react";
// import { useNavigate, useParams, useLoaderData } from "react-router-dom";
// import styled, { ThemeProvider } from "styled-components";
// import { fetchOfficeNavigationDataService } from "../Services/buildingService";
// import useResponsiveLayout from "../Services/useResponsiveLayout";
// import useTimeUpdate from "../Services/useTimeUpdate";

// // Import theme configuration - עדכן את הנתיב לקובץ שלך
// import { getThemeConfig } from "../utils/themeFloor.js";

// // -- Styled Components --
// const Container = styled.div`
//   min-height: 100vh;
//   background: ${props => props.theme.background};
//   color: ${props => props.theme.textColor};
//   font-family: ${props => props.theme.fontFamily};
//   padding: 0;
//   margin: 0;
//   display: flex;
//   flex-direction: column;
// `;

// const Header = styled.header`
//   background: ${props => props.theme.headerBackground};
//   color: ${props => props.theme.headerTextColor};
//   padding: 2rem 0;
//   text-align: center;
//   box-shadow: ${props => props.theme.shadowLarge};
//   position: relative;
//   overflow: hidden;

//   &::before {
//     content: '';
//     position: absolute;
//     top: 0;
//     left: -50%;
//     width: 200%;
//     height: 100%;
//     background: linear-gradient(45deg, transparent, rgba(255,255,255,0.1), transparent);
//     transform: translateX(-100%);
//     animation: shine 3s infinite;
//   }

//   @keyframes shine {
//     0% { transform: translateX(-100%); }
//     50% { transform: translateX(100%); }
//     100% { transform: translateX(100%); }
//   }
// `;

// const Title = styled.h1`
//   font-size: 2.5rem;
//   font-weight: ${props => props.theme.fontWeight.bold};
//   margin: 0;
//   text-shadow: 2px 2px 4px rgba(0,0,0,0.3);

//   @media (max-width: 768px) {
//     font-size: 2rem;
//   }
// `;

// const Subtitle = styled.p`
//   font-size: 1.2rem;
//   margin: 0.5rem 0 0;
//   opacity: 0.9;
//   font-weight: ${props => props.theme.fontWeight.medium};
// `;

// const MainContent = styled.main`
//   flex: 1;
//   padding: 2rem;
//   max-width: 1200px;
//   margin: 0 auto;
//   width: 100%;
// `;

// const FloorGrid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
//   gap: 2rem;
//   margin: 2rem 0;

//   @media (max-width: 768px) {
//     grid-template-columns: 1fr;
//     gap: 1.5rem;
//   }
// `;

// const FloorCard = styled.div`
//   background: ${props => props.theme.cardBackground};
//   border-radius: ${props => props.theme.borderRadius.large};
//   padding: 1.5rem;
//   box-shadow: ${props => props.theme.shadowMedium};
//   border: 1px solid ${props => props.theme.borderColor};
//   transition: all 0.3s ease;
//   position: relative;
//   overflow: hidden;

//   &:hover {
//     transform: translateY(-4px);
//     box-shadow: ${props => props.theme.shadowLarge};
//   }

//   &::before {
//     content: '';
//     position: absolute;
//     top: 0;
//     left: 0;
//     width: 4px;
//     height: 100%;
//     background: ${props => props.theme.accentColor};
//   }
// `;

// const FloorHeader = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   margin-bottom: 1rem;
//   padding-bottom: 1rem;
//   border-bottom: 2px solid ${props => props.theme.borderColor};
// `;

// const FloorTitle = styled.h3`
//   font-size: 1.4rem;
//   font-weight: ${props => props.theme.fontWeight.bold};
//   color: ${props => props.theme.primaryColor};
//   margin: 0;
// `;

// const NavigateButton = styled.button`
//   background: ${props => props.theme.primaryColor};
//   color: white;
//   border: none;
//   padding: 0.5rem 1rem;
//   border-radius: ${props => props.theme.borderRadius.medium};
//   font-size: 0.9rem;
//   font-weight: ${props => props.theme.fontWeight.medium};
//   cursor: pointer;
//   transition: all 0.3s ease;
//   box-shadow: ${props => props.theme.shadowSmall};

//   &:hover {
//     background: ${props => props.theme.primaryColorHover};
//     transform: translateY(-2px);
//     box-shadow: ${props => props.theme.shadowMedium};
//   }

//   &:active {
//     transform: translateY(0);
//   }
// `;

// const BusinessList = styled.ul`
//   list-style: none;
//   padding: 0;
//   margin: 0;
// `;

// const BusinessItem = styled.li`
//   background: ${props => props.theme.businessItemBackground};
//   padding: 1rem;
//   margin: 0.5rem 0;
//   border-radius: ${props => props.theme.borderRadius.medium};
//   border-left: 4px solid ${props => props.theme.accentColor};
//   transition: all 0.2s ease;

//   &:hover {
//     background: ${props => props.theme.businessItemHoverBackground};
//     transform: translateX(4px);
//   }
// `;

// const BusinessName = styled.strong`
//   color: ${props => props.theme.businessNameColor};
//   font-size: 1.1rem;
//   display: block;
//   margin-bottom: 0.5rem;
// `;

// const BusinessDetails = styled.div`
//   font-size: 0.9rem;
//   color: ${props => props.theme.businessDetailsColor};
//   line-height: 1.4;

//   a {
//     color: ${props => props.theme.linkColor};
//     text-decoration: none;

//     &:hover {
//       text-decoration: underline;
//     }
//   }
// `;

// const EmptyState = styled.div`
//   text-align: center;
//   padding: 3rem;
//   color: ${props => props.theme.mutedTextColor};
//   font-style: italic;
// `;

// const LoadingState = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   min-height: 60vh;
//   font-size: 1.2rem;
//   color: ${props => props.theme.mutedTextColor};
// `;

// const BackButton = styled.button`
//   background: ${props => props.theme.secondaryColor};
//   color: white;
//   border: none;
//   padding: 0.8rem 1.5rem;
//   border-radius: ${props => props.theme.borderRadius.medium};
//   font-size: 1rem;
//   font-weight: ${props => props.theme.fontWeight.medium};
//   cursor: pointer;
//   margin: 2rem 0;
//   transition: all 0.3s ease;
//   box-shadow: ${props => props.theme.shadowSmall};

//   &:hover {
//     background: ${props => props.theme.secondaryColorHover};
//     transform: translateY(-2px);
//     box-shadow: ${props => props.theme.shadowMedium};
//   }
// `;

// // Floor-specific view components
// const FloorViewContainer = styled.div`
//   background: ${props => props.theme.cardBackground};
//   border-radius: ${props => props.theme.borderRadius.large};
//   padding: 2rem;
//   margin: 2rem 0;
//   box-shadow: ${props => props.theme.shadowLarge};
// `;

// const DirectionSection = styled.div`
//   margin: 2rem 0;
//   padding: 1.5rem;
//   background: ${props => props.theme.directionSectionBackground};
//   border-radius: ${props => props.theme.borderRadius.medium};
//   border: 2px solid ${props => props.theme.directionBorderColor};
// `;

// const DirectionTitle = styled.h3`
//   color: ${props => props.theme.directionTitleColor};
//   font-size: 1.3rem;
//   font-weight: ${props => props.theme.fontWeight.bold};
//   margin: 0 0 1rem 0;
//   display: flex;
//   align-items: center;

//   &::before {
//     content: '→';
//     margin-left: 0.5rem;
//     font-size: 1.5rem;
//     color: ${props => props.theme.accentColor};
//   }
// `;

// // -- Loader לנתיב --
// export const loader = async ({ params }) => {
//   const data = await fetchOfficeNavigationDataService(params.buildingId, params.floorNumber);
//   return data;
// };

// const ShowOfficeNavigationScreen = () => {
//   const { buildingId, floorNumber } = useParams();
//   const navigate = useNavigate();
//   const data = useLoaderData();

//   const [officeData, setOfficeData] = useState(data || null);
//   const [address, setAddress] = useState("");
//   const [template, setTemplate] = useState("professional");

//   const { orientation, gridRows, getResponsiveMargin } = useResponsiveLayout();
//   const { currentTime, dayOfWeek, updateTime } = useTimeUpdate();

//   // Load theme - פשוט יותר ללא תלות בקבצים חיצוניים
//   const theme = getThemeConfig(template);

//   // console.log("Current theme:", theme);

//   // טען מחדש נתונים אם buildingId/floorNumber משתנים
//   const fetchOfficeData = useCallback(async () => {
//     try {
//       const response = await fetchOfficeNavigationDataService(buildingId, floorNumber);
//       setOfficeData(response);

//       // כתובת ותבנית
//       if (response.city && response.street && response.houseNumber) {
//         setAddress(`${response.city} ${response.street} ${response.houseNumber}`);
//       } else if (response.nickname) {
//         setAddress(response.nickname);
//       }
//       setTemplate(response.designTemplate || "professional");
//     } catch (error) {
//       setOfficeData(null);
//       console.error("Error fetching office data:", error);
//     }
//   }, [buildingId, floorNumber]);

//   useEffect(() => {
//     fetchOfficeData();
//     const timeInterval = setInterval(updateTime, 30000);
//     const dataInterval = setInterval(fetchOfficeData, 300000);
//     return () => {
//       clearInterval(timeInterval);
//       clearInterval(dataInterval);
//     };
//   }, [fetchOfficeData, updateTime]);

//   if (!officeData) {
//     return (
//       <ThemeProvider theme={theme}>
//         <Container>
//           <LoadingState>טוען נתוני משרד...</LoadingState>
//         </Container>
//       </ThemeProvider>
//     );
//   }

//   // תצוגה לפי מצב: קומה ספציפית או כל הבניין
//   if (floorNumber) {
//     // -- תצוגת קומה בלבד --
//     if (!officeData.businesses?.length) {
//       return (
//         <ThemeProvider theme={theme}>
//           <Container>
//             <Header>
//               <Title>קומה {officeData.floorNumber}</Title>
//               <Subtitle>{officeData.floorName}</Subtitle>
//             </Header>
//             <MainContent>
//               <FloorViewContainer>
//                 <EmptyState>לא נמצאו עסקים בקומה זו</EmptyState>
//                 <BackButton onClick={() => navigate(`/office/${buildingId}`)}>
//                   חזרה לכל הקומות
//                 </BackButton>
//               </FloorViewContainer>
//             </MainContent>
//           </Container>
//         </ThemeProvider>
//       );
//     }

//     // חלוקה לפי אזור/כיוון (אם יש)
//     const groupedByDirection = officeData.businesses.reduce((acc, business) => {
//       const dir = business.direction || "אחר";
//       acc[dir] = acc[dir] || [];
//       acc[dir].push(business);
//       return acc;
//     }, {});

//     return (
//       <ThemeProvider theme={theme}>
//         <Container>
//           <Header>
//             <Title>קומה {officeData.floorNumber}</Title>
//             <Subtitle>{officeData.floorName}</Subtitle>
//           </Header>
//           <MainContent>
//             <FloorViewContainer>
//               {Object.entries(groupedByDirection).map(([direction, businesses]) => (
//                 <DirectionSection key={direction}>
//                   <DirectionTitle>{direction}</DirectionTitle>
//                   <BusinessList>
//                     {businesses.map((b, idx) => (
//                       <BusinessItem key={idx}>
//                         <BusinessName>{b.name}</BusinessName>
//                         <BusinessDetails>
//                           {b.phone && <div>טלפון: {b.phone}</div>}
//                           {b.website && (
//                             <div>
//                               <a href={b.website} target="_blank" rel="noopener noreferrer">
//                                 אתר אינטרנט
//                               </a>
//                             </div>
//                           )}
//                         </BusinessDetails>
//                       </BusinessItem>
//                     ))}
//                   </BusinessList>
//                 </DirectionSection>
//               ))}
//               <BackButton onClick={() => navigate(`/office/${buildingId}`)}>
//                 חזרה לכל הקומות
//               </BackButton>
//             </FloorViewContainer>
//           </MainContent>
//         </Container>
//       </ThemeProvider>
//     );
//   }

//   // -- תצוגה מלאה של כל הבניין --
//   if (!officeData.floors?.length) {
//     return (
//       <ThemeProvider theme={theme}>
//         <Container>
//           <Header>
//             <Title>לא נמצאו קומות</Title>
//             <Subtitle>במבנה זה</Subtitle>
//           </Header>
//         </Container>
//       </ThemeProvider>
//     );
//   }

//   return (
//     <ThemeProvider theme={theme}>
//       <Container>
//         <Header>
//           <Title>{officeData.buildingType}</Title>
//           <Subtitle>{address}</Subtitle>
//         </Header>
//         <MainContent>
//           <FloorGrid>
//             {officeData.floors
//               .sort((a, b) => b.floorNumber - a.floorNumber) // מיון מקומה עליונה לתחתונה
//               .map((floor) => (
//                 <FloorCard key={floor.floorNumber}>
//                   <FloorHeader>
//                     <FloorTitle>
//                       קומה {floor.floorNumber} – {floor.floorName}
//                     </FloorTitle>
//                     <NavigateButton
//                       onClick={() => navigate(`/office/${buildingId}/${floor.floorNumber}`)}
//                     >
//                       ניווט קומה
//                     </NavigateButton>
//                   </FloorHeader>

//                   {floor.businesses?.length ? (
//                     <BusinessList>
//                       {floor.businesses.map((business, idx) => (
//                         <BusinessItem key={idx}>
//                           <BusinessName>{business.name}</BusinessName>
//                           <BusinessDetails>
//                             {business.direction && <div>אזור: {business.direction}</div>}
//                             {business.phone && <div>טלפון: {business.phone}</div>}
//                             {business.website && (
//                               <div>
//                                 <a href={business.website} target="_blank" rel="noopener noreferrer">
//                                   אתר אינטרנט
//                                 </a>
//                               </div>
//                             )}
//                           </BusinessDetails>
//                         </BusinessItem>
//                       ))}
//                     </BusinessList>
//                   ) : (
//                     <EmptyState>אין עסקים בקומה זו</EmptyState>
//                   )}
//                 </FloorCard>
//               ))}
//           </FloorGrid>
//         </MainContent>
//       </Container>
//     </ThemeProvider>
//   );
// };

// export default ShowOfficeNavigationScreen;

import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useParams, useLoaderData } from "react-router-dom";
import styled, { ThemeProvider } from "styled-components";
import { fetchOfficeNavigationDataService } from "../Services/buildingService";
import useResponsiveLayout from "../Services/useResponsiveLayout";
import useTimeUpdate from "../Services/useTimeUpdate";
import { getThemeConfig } from "../utils/themeFloor.js";

// --- Styled Components ---
const Container = styled.div`
  min-height: 100vh;
  background: ${(props) => props.theme.background};
  color: ${(props) => props.theme.textColor};
  font-family: ${(props) => props.theme.fontFamily};
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
`;

const Header = styled.header`
  background: ${(props) => props.theme.headerBackground};
  color: ${(props) => props.theme.headerTextColor};
  padding: 2rem 0 2rem 0;
  text-align: center;
  box-shadow: ${(props) => props.theme.shadowLarge};
  position: relative;
  font-size: 4rem;
  font-weight: bold;
  letter-spacing: 1px;
  z-index: 2;
`;

const MainContent = styled.main`
  flex: 1;
  padding: 0rem 0;
  margin: 0 auto;
  width: 100%;
  height: 100%;
  direction: rtl;
`;

const FloorLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr 5fr 20px;
  gap: 1.8rem;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 30px 0;
  box-sizing: border-box;
  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 0.7rem;
  }
`;

// const FloorBox = styled.div`
//   background: ${(props) => props.theme.cardBackground};
//   border-radius: ${(props) => props.theme.borderRadius.large};
//   box-shadow: ${(props) => props.theme.shadowLarge};
//   padding: 100% 1.2rem;
//   min-width: 180px;
//   text-align: center;
//   ${'' /* margin-top: 30px; */}
//   margin-right: 2rem;
//   border: 2.5px solid ${(props) => props.theme.primaryColor || "#2cb1bc"};
//   color: ${(props) => props.theme.primaryColor};
//   font-size: 1.5rem;
//   font-weight: bold;
// `;

const FloorBox = styled.div`
  background: ${(props) => props.theme.cardBackground};
  border-radius: ${(props) => props.theme.borderRadius.large};
  box-shadow: ${(props) => props.theme.shadowLarge};
  min-width: 180px;
  text-align: center;
  margin-right: 2rem;
  border: 2.5px solid ${(props) => props.theme.primaryColor || "#2cb1bc"};
  color: ${(props) => props.theme.primaryColor};
  font-size: 1.5rem;
  font-weight: bold;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;    
  align-items: center;            
  padding: 100% 1.2rem;
  height: 100%;
  box-sizing: border-box;
`;

const BusinessesCol = styled.div`
  background: ${(props) => props.theme.cardBackground};
  border-radius: ${(props) => props.theme.borderRadius.large};
  box-shadow: ${(props) => props.theme.shadowLarge};
  padding: 2.3rem 1.2rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  ${'' /* margin-top: 2rem; */}

  /* מה שחשוב! */
  height: 100%;
  flex: 1 1 auto;
`;

const BusinessList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const BusinessItem = styled.li`
  background: ${(props) => props.theme.businessItemBackground};
  padding: 1rem 0.9rem;
  margin: 0.5rem 0;
  border-radius: ${(props) => props.theme.borderRadius.medium};
  border-right: 5px solid ${(props) => props.theme.accentColor};
  transition: all 0.2s ease;
  font-size: 1.1rem;
  box-shadow: ${(props) => props.theme.shadowSmall};
  &:hover {
    background: ${(props) => props.theme.businessItemHoverBackground};
    transform: translateX(-3px);
  }
`;

const BusinessName = styled.strong`
  color: ${(props) => props.theme.businessNameColor};
  font-size: 1.14rem;
  display: block;
  margin-bottom: 0.5rem;
`;

const BusinessDetails = styled.div`
  font-size: 0.93rem;
  color: ${(props) => props.theme.businessDetailsColor};
  line-height: 1.45;
  direction: ltr;
  text-align: left;
  a {
    color: ${(props) => props.theme.linkColor};
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;

const Divider = styled.div`
  width: 60%;
  height: 2.5px;
  margin: 2rem auto 1.3rem auto;
  background: ${(props) => props.theme.accentColor || "#2cb1bc"};
  opacity: 0.44;
`;

const SectionTitle = styled.h3`
  color: ${(props) => props.theme.primaryColor};
  margin-bottom: 1.2rem;
  font-weight: 600;
  font-size: 1.17rem;
  letter-spacing: 1.1px;
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 3rem 0;
  color: ${(props) => props.theme.mutedTextColor};
  font-style: italic;
  font-size: 1.1rem;
`;

const LoadingState = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  font-size: 1.2rem;
  color: ${(props) => props.theme.mutedTextColor};
`;

const BackButton = styled.button`
  background: ${(props) => props.theme.secondaryColor};
  color: white;
  border: none;
  padding: 0.8rem 1.5rem;
  border-radius: ${(props) => props.theme.borderRadius.medium};
  font-size: 1rem;
  font-weight: ${(props) => props.theme.fontWeight.medium};
  cursor: pointer;
  margin: 2rem auto 0 auto;
  display: block;
  transition: all 0.3s ease;
  box-shadow: ${(props) => props.theme.shadowSmall};
  &:hover {
    background: ${(props) => props.theme.secondaryColorHover};
    transform: translateY(-2px);
    box-shadow: ${(props) => props.theme.shadowMedium};
  }
`;

// --- Loader לנתיב ---
export const loader = async ({ params }) => {
  const data = await fetchOfficeNavigationDataService(
    params.buildingId,
    params.floorNumber
  );
  console.log(data);

  return data;
};

const ShowOfficeNavigationScreen = () => {
  const { buildingId, floorNumber } = useParams();
  const navigate = useNavigate();
  const data = useLoaderData();

  const [officeData, setOfficeData] = useState(data || null);
  const [address, setAddress] = useState("");
  const [template, setTemplate] = useState("professional");

  const { orientation } = useResponsiveLayout();
  const { updateTime } = useTimeUpdate();

  // טען תצורה עיצובית
  const theme = getThemeConfig(template);

  // קבלת נתונים שוב במידת הצורך
  const fetchOfficeData = useCallback(async () => {
    try {
      const response = await fetchOfficeNavigationDataService(
        buildingId,
        floorNumber
      );
      setOfficeData(response);
      setAddress(response.title);
      setTemplate(response.designTemplate || "default");
    } catch (error) {
      setOfficeData(null);
      console.error("Error fetching office data:", error);
    }
  }, [buildingId, floorNumber]);

  useEffect(() => {
    fetchOfficeData();
    const timeInterval = setInterval(updateTime, 30000);
    const dataInterval = setInterval(fetchOfficeData, 300000);
    return () => {
      clearInterval(timeInterval);
      clearInterval(dataInterval);
    };
  }, [fetchOfficeData, updateTime]);

  if (!officeData) {
    return (
      <ThemeProvider theme={theme}>
        <Container>
          <LoadingState>טוען נתוני משרד...</LoadingState>
        </Container>
      </ThemeProvider>
    );
  }

  // == תצוגת קומה בודדת ==
  if (floorNumber) {
    if (!officeData.businesses?.length) {
      return (
        <ThemeProvider theme={theme}>
          <Container>
            <Header>{address || officeData.buildingType}</Header>
            <MainContent>
              <FloorLayout>
                <FloorBox>
                  <div>קומה {officeData.floorNumber}</div>
                  <div
                    style={{
                      color: theme.textSecondaryColor,
                      marginTop: "0.6rem",
                    }}
                  >
                    {officeData.floorName}
                  </div>
                </FloorBox>
                <BusinessesCol>
                  <EmptyState>לא נמצאו עסקים בקומה זו</EmptyState>
                  <BackButton onClick={() => navigate(`/office/${buildingId}`)}>
                    חזרה לכל הקומות
                  </BackButton>
                </BusinessesCol>
                <div />
              </FloorLayout>
            </MainContent>
          </Container>
        </ThemeProvider>
      );
    }

    // חלוקה לצד ימין / שמאל לפי direction
    const rightBusinesses = officeData.businesses.filter(
      (b) =>
        b.direction?.includes("ימין") ||
        b.direction?.includes("מזרח") ||
        b.direction?.includes("צפון")
    );
    const leftBusinesses = officeData.businesses.filter(
      (b) =>
        b.direction?.includes("שמאל") ||
        b.direction?.includes("מערב") ||
        b.direction?.includes("דרום")
    );
    const otherBusinesses = officeData.businesses.filter(
      (b) =>
        !(
          b.direction?.includes("ימין") ||
          b.direction?.includes("מזרח") ||
          b.direction?.includes("צפון") ||
          b.direction?.includes("שמאל") ||
          b.direction?.includes("מערב") ||
          b.direction?.includes("דרום")
        )
    );

    return (
      <ThemeProvider theme={theme}>
        <Container>
          <Header>{address || officeData.buildingType}</Header>
          <MainContent>
            <FloorLayout>
              <FloorBox>
                  <div
                  style={{
                    color: theme.textSecondaryColor,
                    marginTop: "0.6rem",
                    fontSize: "3rem",
                  }}
                >קומה</div>
                <div
                  style={{
                    color: theme.textSecondaryColor,
                    marginTop: "0.6rem",
                    fontSize: "10rem",
                  }}
                >
                  {officeData.floorNumber}
                </div>
              </FloorBox>
              <BusinessesCol>
                <section>
                  <SectionTitle>עסקים צד ימין</SectionTitle>
                  <BusinessList>
                    {rightBusinesses.length === 0 && (
                      <EmptyState>אין עסקים בצד ימין</EmptyState>
                    )}
                    {rightBusinesses.map((b, idx) => (
                      <BusinessItem key={idx}>
                        <BusinessName>{b.name}</BusinessName>
                        <BusinessDetails>
                          {b.phone && <div>טלפון: {b.phone}</div>}
                          {b.website && (
                            <div>
                              <a
                                href={b.website}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                אתר אינטרנט
                              </a>
                            </div>
                          )}
                        </BusinessDetails>
                      </BusinessItem>
                    ))}
                  </BusinessList>
                </section>
                <Divider />
                <section>
                  <SectionTitle>עסקים צד שמאל</SectionTitle>
                  <BusinessList>
                    {leftBusinesses.length === 0 && (
                      <EmptyState>אין עסקים בצד שמאל</EmptyState>
                    )}
                    {leftBusinesses.map((b, idx) => (
                      <BusinessItem key={idx}>
                        <BusinessName>{b.name}</BusinessName>
                        <BusinessDetails>
                          {b.phone && <div>טלפון: {b.phone}</div>}
                          {b.website && (
                            <div>
                              <a
                                href={b.website}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                אתר אינטרנט
                              </a>
                            </div>
                          )}
                        </BusinessDetails>
                      </BusinessItem>
                    ))}
                  </BusinessList>
                </section>
                {otherBusinesses.length > 0 && (
                  <>
                    <Divider />
                    <SectionTitle>עסקים ללא שיוך צד</SectionTitle>
                    <BusinessList>
                      {otherBusinesses.map((b, idx) => (
                        <BusinessItem key={idx}>
                          <BusinessName>{b.name}</BusinessName>
                          <BusinessDetails>
                            {b.phone && <div>טלפון: {b.phone}</div>}
                            {b.website && (
                              <div>
                                <a
                                  href={b.website}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  אתר אינטרנט
                                </a>
                              </div>
                            )}
                          </BusinessDetails>
                        </BusinessItem>
                      ))}
                    </BusinessList>
                  </>
                )}
              </BusinessesCol>
              <div />
            </FloorLayout>
          </MainContent>
        </Container>
      </ThemeProvider>
    );
  }

  // == תצוגה של כל הבניין ==
  if (!officeData.floors?.length) {
    return (
      <ThemeProvider theme={theme}>
        <Container>
          <Header>לא נמצאו קומות</Header>
        </Container>
      </ThemeProvider>
    );
  }

  // תצוגה רגילה – כל הקומות
  return (
    <ThemeProvider theme={theme}>
      <Container>
        <Header>
          {officeData.buildingType}
          <div
            style={{
              fontSize: "1.08rem",
              fontWeight: "normal",
              marginTop: "0.7rem",
            }}
          >
            {address}
          </div>
        </Header>
        <MainContent>
          <div style={{ margin: "2rem auto", maxWidth: "1200px" }}>
            {officeData.floors
              .sort((a, b) => b.floorNumber - a.floorNumber)
              .map((floor) => (
                <BusinessesCol key={floor.floorNumber}>
                  <SectionTitle>
                    קומה {floor.floorNumber} – {floor.floorName}
                  </SectionTitle>
                  {floor.businesses?.length ? (
                    <BusinessList>
                      {floor.businesses.map((business, idx) => (
                        <BusinessItem key={idx}>
                          <BusinessName>{business.name}</BusinessName>
                          <BusinessDetails>
                            {business.direction && (
                              <div>אזור: {business.direction}</div>
                            )}
                            {business.phone && (
                              <div>טלפון: {business.phone}</div>
                            )}
                            {business.website && (
                              <div>
                                <a
                                  href={business.website}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  אתר אינטרנט
                                </a>
                              </div>
                            )}
                          </BusinessDetails>
                        </BusinessItem>
                      ))}
                    </BusinessList>
                  ) : (
                    <EmptyState>אין עסקים בקומה זו</EmptyState>
                  )}
                </BusinessesCol>
              ))}
          </div>
        </MainContent>
      </Container>
    </ThemeProvider>
  );
};

export default ShowOfficeNavigationScreen;
